export interface ShipperUser {
  shipperUserId?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  phoneNumber?: string;
  homeAddress?: string;
  shipperId?: number;
  groupIds?: number[];
  groups?: Groups[];
}

export interface Groups {
  groupId: number;
  name: string;
}

export const ShipperUserGroups: Groups[] = [
  { groupId: 1, name: 'Admin' },
  { groupId: 2, name: 'Restricted User' },
];
